/*
 * Copyright (c) Kalaora 2022.
 * Author: fharold
 *
 * hilo-oauth-manager
 * FormInput.tsx
 */

import HiloReactComponent from "../layout/HiloReactComponent";
import React from "react";
import {FormElementProps} from "./FormElement";
import Button from "../element/button/Button";
import Colors from "../../model/enumerations/Colors";
import {DownloadField} from "../../model/form/DownloadField";
import AuthenticationService from "../../service/AuthenticationService";

interface Props<D> extends FormElementProps<D> {
}

interface State {
}

export default class FormFileDownload<D> extends HiloReactComponent<Props<D>, State> {
    private _authService: AuthenticationService

    constructor(props: Props<D>, state: State) {
        super(props, state);

        this._authService = this._serviceRepository.resolve(AuthenticationService.id) as AuthenticationService

        this.state = {}
    }

    /**
     * render
     * @returns {any}
     */
    public render() {
        const {field} = this.props;

        if (!(field instanceof DownloadField) || field.url === undefined) return <p>Pas encore de fichier</p>;

        let url = field.url + "?access_token=" + this._authService.token?.access_token

        return <div className="field">
            <span>{field.title(this.t)}</span>
            <a className={"download-link"} href={url} target="_blank" rel="noopener noreferrer" download>
                <Button color={Colors.light_grey} labelAccessor={t => t.download}/>
            </a>
        </div>;
    }
}